// Copyright (c) 2026 Joshua S. Plaza. All rights reserved.

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sidebarOpen: false,
  notification: {
    open: false,
    message: '',
    severity: 'info',
  },
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload;
    },
    showNotification: (state, action) => {
      state.notification = {
        open: true,
        message: action.payload.message,
        severity: action.payload.severity || 'info',
      };
    },
    hideNotification: (state) => {
      state.notification.open = false;
    },
  },
});

export const {
  toggleSidebar,
  setSidebarOpen,
  showNotification,
  hideNotification,
} = uiSlice.actions;

export default uiSlice.reducer;
